import { baseYear } from "constants/constants";

interface YearOption {
    label: string;
    value: string;
  }
  
  export const getYearOptions = (): YearOption[] => {
    const currentYear = new Date().getFullYear();
    const yearOptions: YearOption[] = [];
  
    for (let year = baseYear; year <= currentYear; year++) {
      yearOptions.push({
        label: year.toString(),
        value: year.toString(),
      });
    }
  
    return yearOptions;
  };
  